/* eslint-disable complexity */
import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import LeadRegNo from "../lead-reg-no";
import loadable from "@loadable/component";

const LeadFormRevamp = loadable(() => import("../lead-form-revamp"));
const LeadPhoneNumberWrapper = loadable(() => import("../lead-phone-number-wrapper"));
const UserSellCarContent = loadable(() => import("../user-sell-car-intent"));

const LeadFormWrapper = ({
    leadData,
    setIsFetching,
    setIsDuplicateAppointment,
    setShowDupModalConnect,
    getQuestionForUserIntentConnect = () => {},
    ctaText,
    isBrandsVisible,
    isScrapBenefitsVisible,
    setIsPhoneNumberChange,
    isAllianceOffer,
    isLuxuryPage,
    isDlsCompliant,
    isLoggedIn
}) => {

    const [question, setQuestion] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const { activateFirstStep, askUserIntent, activateLastStep, showWidget } = leadData;
    useEffect(() => {
        if (!question && !activateFirstStep) {
            getQuestionForUserIntentConnect()
                .then((response) => {
                    setQuestion(response);
                })
                .catch(() => {
                });
        }
    }, [getQuestionForUserIntentConnect, question, activateFirstStep]);

    return (
        <div>
            {
                activateFirstStep &&
                <LeadRegNo ctaText={ctaText} isBrandsVisible={isBrandsVisible} isScrapBenefitsVisible={isScrapBenefitsVisible} isAllianceOffer={isAllianceOffer} isLuxuryPage={isLuxuryPage} isDlsCompliant={isDlsCompliant}/>
            }
            {
                !activateFirstStep && !askUserIntent && !activateLastStep &&
                <LeadFormRevamp setIsPhoneNumberChange={setIsPhoneNumberChange} setIsDuplicateAppointment={setIsDuplicateAppointment} setShowDupModalConnect={setShowDupModalConnect} />
            }
            {!activateFirstStep && askUserIntent && !showWidget && <UserSellCarContent question={question} isLoggedIn={isLoggedIn}  setIsFetching={setIsFetching}
                setIsDuplicateAppointment={setIsDuplicateAppointment}
                setShowDupModalConnect={setShowDupModalConnect}
                setIsPhoneNumberChange={setIsPhoneNumberChange}
                isAllianceOffer={isAllianceOffer}
                setIsLoading={setIsLoading}
                isLoading={isLoading}
            />}
            {
                (
                    (activateLastStep && !activateFirstStep && !showWidget && !askUserIntent && !isLoggedIn) ||
                    (activateLastStep && isLoggedIn && isLoading &&  !activateFirstStep && !showWidget  && !askUserIntent)
                ) &&
            <LeadPhoneNumberWrapper
                setIsFetching={setIsFetching}
                setIsDuplicateAppointment={setIsDuplicateAppointment}
                setShowDupModalConnect={setShowDupModalConnect}
                setIsPhoneNumberChange={setIsPhoneNumberChange}
                isAllianceOffer={isAllianceOffer}
            /> }

        </div>
    );
};

LeadFormWrapper.propTypes = {
    leadData: PropTypes.object,
    setIsFetching: PropTypes.func,
    setIsDuplicateAppointment: PropTypes.func,
    setShowDupModalConnect: PropTypes.func,
    getQuestionForUserIntentConnect: PropTypes.func,
    ctaText: PropTypes.string,
    isBrandsVisible: PropTypes.bool,
    isScrapBenefitsVisible: PropTypes.bool,
    setIsPhoneNumberChange: PropTypes.func,
    isAllianceOffer: PropTypes.bool,
    isLuxuryPage: PropTypes.bool,
    isDlsCompliant: PropTypes.bool,
    isLoggedIn: PropTypes.bool
};

export default LeadFormWrapper;
